import { render, staticRenderFns } from "./report-gross-profit.vue?vue&type=template&id=36ea2316&scoped=true"
import script from "./report-gross-profit.vue?vue&type=script&lang=ts"
export * from "./report-gross-profit.vue?vue&type=script&lang=ts"
import style0 from "./report-gross-profit.vue?vue&type=style&index=0&id=36ea2316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea2316",
  null
  
)

export default component.exports